module.exports = __webpack_public_path__ + "img/01安全气囊控制器软件著作权.93f6fbe7.png";